<template>
  <el-dialog
    title="Időszaki munka megtekintése"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    @close="$router.replace('/representative-processes/tasks')"
  >
    <div slot="title">
      <span> Időszaki munka megtekintése </span>
      <el-tag
        type="success"
        v-if="task && task.status === 'done'"
        size="small"
      >Kész
      </el-tag>
      <el-tag
        type="warning"
        v-if="task && task.status === 'in-progress'"
        size="small"
      >Folyamatban
      </el-tag>
      <el-tag
        type="danger"
        v-if="task && task.status === 'todo'"
        size="small"
      >Elintézendő
      </el-tag>
    </div>
    <div v-loading="loading">
      <el-row
        :gutter="20"
        style="display: flex; align-items: center">
        <el-col
          :span="7"
          style="align-self: flex-start">
          <p><strong>Képviselő: </strong> {{ task.user && task.user.full_name }}</p>
          <p><strong>Üzlet: </strong> {{ task.shop && task.shop.name }}</p>
          <p>
            <strong>Típus: </strong>
            <span v-if="task.type === 'photo'">Képkészítés</span>
            <span v-if="task.type === 'measure'">Disztribúciós felmérés</span>
            <span v-if="task.type === 'questionnaire'">Kérdőív</span>
          </p>
        </el-col>

        <el-col :span="17">
          <div v-if="task && task.type === 'photo'">
            <el-carousel
              v-if="task.images.length"
              height="200"
            >
              <el-carousel-item
                v-for="image in task.images"
                :key="image.id"
                style="text-align: center"
              >
                <a
                  :href="image.image && image.image.full"
                  target="_blank"
                >
                  <el-image
                    fit="contain"
                    :src="image.image && image.image.full"
                  />
                </a>
              </el-carousel-item>
            </el-carousel>
            <div
              v-else
              style="text-align: center"
            >
              Még nincs feltöltve kép
            </div>
          </div>
          <div v-if="task && task.type === 'questionnaire'">
            <div v-if="task.questionnaire_result.length">
              <div
                v-for="(conversation, index) in task.questionnaire_result.slice().reverse()"
                :key="conversation.id">
                <p><strong>{{ index + 1 }}. {{ conversation.question && conversation.question.question }}</strong></p>
                <p style="margin-left: 10px">{{ conversation.answer && conversation.answer.answer }}</p>
              </div>
            </div>
            <div
              v-else
              style="text-align: center">Még nincsenek megválaszolva a kérdések
            </div>
          </div>
          <div v-if="task && task.type === 'measure'">
            <div v-if="task.status === 'done' && task.products && task.products.length">
              <el-table
                :data="task.products"
                border
                :default-sort="{prop: 'is_available', order: 'descending'}"
                height="300"
              >
                <el-table-column
                  prop="product.product"
                  label="Termék"
                >
                  <template slot-scope="scope"> {{ scope.row.product.name }}</template>
                </el-table-column>
                <el-table-column
                  prop="is_available"
                  label="Van készleten"
                >
                  <template slot-scope="scope">
                    <el-tag
                      size="small"
                      type="success"
                      v-if="scope.row.is_available"
                    >Igen
                    </el-tag>
                    <el-tag
                      size="small"
                      type="danger"
                      v-if="!scope.row.is_available"
                    >Nem
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              v-else
              style="text-align: center"
            >
              Felmérés még nem készült el
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['taskId'],
    data() {
      return {
        task: {},
        loading: false,
      };
    },
    async mounted() {
      this.loading = true;
      this.task = await this.$store.dispatch('task/fetch', this.taskId);
      this.loading = false;
    },
  };
</script>
